<section class="filters global-filters-container">
    <lib-search-input
        [text]="filters.searchText"
        (textChange)="onSearchTextChanged($event)"
        [placeholderText]="'Contact Info'"
        name="search"
    >
    </lib-search-input>
    <app-additional-filters class="filter" [config]="additionalFiltersConfig"></app-additional-filters>
    <app-clear-filters-button></app-clear-filters-button>
</section>
